import { useState, useCallback, useRef, useMemo } from 'react';
import type { GoalWithId, SubGoals } from '../../../../../../../../../common/types';
import { NEW, NEW_AND_MODIFIED } from '../../../../../../../../../common/ui/constants';
import { useMetricResource } from '../../../../../../../../../controllers/metric-resource/index.tsx';
import { useFetchPrioritiesService } from '../../../../../../../../../services/fetch-priorities/index.tsx';
import { appendNewSubGoal, formatOptions } from './utils';

export const useSubGoalsState = (intialSubGoals: SubGoals = [], goal: GoalWithId) => {
	const newSubGoalReference = useRef(0);
	const [subGoals, setSubGoals] = useState<SubGoals>(intialSubGoals);
	const [{ data }] = useMetricResource();
	const calendarOptions = useMemo(() => formatOptions(data?.calendarRefs ?? []), [data]);
	const defaultCalendarOption = calendarOptions.find(({ isDefaultOption }) => isDefaultOption);

	const [{ values: prioritiesOptions }] = useFetchPrioritiesService();
	const defaultPriorityOption = prioritiesOptions[prioritiesOptions.length - 1];

	const onAppendNewSubGoal = useCallback(() => {
		newSubGoalReference.current += 1;
		const newList = appendNewSubGoal(subGoals, {
			id: `new-subgoal-with-id-${newSubGoalReference.current}`,
			jqlQuery: `priority=${defaultPriorityOption?.value}`,
			duration: '',
			calendarId: defaultCalendarOption?.value,
			calendarName: defaultCalendarOption?.label,
			defaultGoal: false,
			// For new Goal, if we add subGoals, the subGoal should not have goalId
			// since these are new subGoals
			...(goal.fieldState === NEW || goal.fieldState === NEW_AND_MODIFIED
				? {}
				: { goalId: goal.id }),
			// @ts-expect-error - TS2345 - 'fieldState' does not exist in type 'SubGoal'
			fieldState: 'NEW',
		});
		// @ts-expect-error - TS2345 - Argument of type 'readonly [...GoalWithId[], GoalWithId]' is not assignable to parameter of type 'SetStateAction<GoalWithIds>'.
		setSubGoals(newList);
	}, [goal, subGoals, defaultCalendarOption, defaultPriorityOption]);

	return [subGoals, setSubGoals, onAppendNewSubGoal] as const;
};
